import { createRouter, createWebHashHistory } from 'vue-router'
import CreateProject from '../views/createProject/CreateProject.vue'
import EditProject from '../views/createProject/EditProject.vue'
import DropData from '../views/dropData/DropData.vue'
import ThirdPlatform from '../views/thirdPlatform/ThirdPlatform.vue'
import ApplicationConfig from '../views/applicationConfig/ApplicationConfig.vue'
import CustomerData from '../views/customerData/customerData.vue'
import CustomerVersion from '../views/CustomerVersion/CustomerVersion.vue'
import EditApplication from '../views/applicationConfig/EditApplication.vue'
import NameList from '../views/applicationConfig/NameList.vue'
import AdvertisingList from '../views/createProject/AdvertisingList.vue'

const routes = [
  {
    path: '/create-project',
    name: 'Home',
    component: CreateProject
  },
  {
    path: '/create-project/:state/:id',
    name: 'project-edit',
    component: EditProject
  },
  {
    path: '/drop-data',
    name: 'drop-data',
    component: DropData
  },
  {
    path: '/third-platform',
    name: 'third-platform',
    component: ThirdPlatform
  },
  {
    path: '/application-config',
    name: 'application-config',
    component: ApplicationConfig
  },
  {
    path: '/customer-data',
    name: 'customer-data',
    component: CustomerData
  },
  {
    path: '/customer-version',
    name: 'customer-version',
    component: CustomerVersion
  },
  {
    path: '/application-config/:state/:id',
    name: 'application-edit',
    component: EditApplication
  },
  {
    path: '/application-config/nameList',
    name: 'name-list',
    component: NameList
  },
  {
    path: '/advertising-list/:id',
    name: 'advertising-list',
    component: AdvertisingList
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
